import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-[#FAF7F2] px-5">
      <div className="text-center max-w-md" data-testid="payment-cancel-page">
        <div className="w-16 h-16 rounded-full bg-[#F4E3E2] flex items-center justify-center mx-auto mb-6">
          <Heart className="w-8 h-8 text-[#6E2D38]" />
        </div>
        <h1 className="font-editorial text-3xl font-medium mb-3">Pas de souci</h1>
        <p className="text-[#5C4A45] mb-6">
          Le paiement a été interrompu. Ta conversation avec Maryline est conservée, tu peux
          reprendre quand tu le souhaites.
        </p>
        <button onClick={() => { const c = localStorage.getItem("rawlove_pending_cid"); navigate(c ? `/chat?c=${c}` : "/chat"); }} data-testid="cancel-back-button"
          className="bg-[#6E2D38] hover:bg-[#54212A] text-white rounded-full px-6 py-3 font-medium transition-all hover:-translate-y-0.5">
          Reprendre ma conversation
        </button>
      </div>
    </div>
  );
}
